<div class="totalContainer">
  <header>
    <div class="top_box position-relative">
      <div class="container-fluid w-90">
        <div class="row align-items-center">
          <div class="col-md-4">
            <div class="logo">
              <img
                src="{{ myLinksS3URL }}frontend/presentation22/images/logo.png"
                alt="logo"
                class="img-fluid main_image_one"
              />
            </div>
          </div>

          <div class="col-md-5">
            <p class="mt-3">You Are Invited By :- {{ userName }}</p>
          </div>
          <div class="col-md-3">
            <div class="top_right">
              <ul>
                <li data-aos="fade-right" data-aos="fade-right" class="sign-up">
                  <a
                    [routerLink]="'.'"
                    [queryParams]="{ reg: referralId }"
                    [fragment]="'regform'"
                    class="go"
                    style="border-right: none"
                  >
                    <!-- <i class="fas fa-edit fa-1x"></i>  -->
                    Signup
                  </a>
                </li>
                <!-- <li data-aos="fade-left" data-aos="fade-left"><a routerLink="/login"><i class="fas fa-sign-in-alt fa-2x"></i> Signin</a></li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

  <section class="presentation-banner">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7">
          <div class="banner-content text-white">
            <h5
              class="text-uppercase our"
              data-aos="fade-right"
              data-aos-delay="800"
            >
              PRESENTING OUR
            </h5>

            <h1
              class="league text-uppercase"
              data-aos="fade-right"
              data-aos-delay="400"
            >
              ULTIMATE <br />
              RESIDUAL INCOME
            </h1>
          </div>
        </div>

        <div class="col-lg-5"></div>
      </div>
      <div class="yellowheader">
        <div class="col-lg-12">
          <h1 class="opportunity">Opportunity</h1>
        </div>
      </div>
    </div>
  </section>

  <section class="back">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12 blue_box margin-top">
          <div class="row">
            <div class="col-lg-7 text-white">
              <div class="padding">
                <h2 class="extrabold">WELCOME O-FOUNDERS!</h2>
                <p><br /></p>
                <p class="glacial">
                  All the big dreamers make your move now! We welcome you to
                  experience the Unbelievable. The ULTIMATE INCOME OPPORTUNITY
                  that generates long-term residual payments, which can continue
                  for life. Introducing for the FIRST TIME a NEVER-SEEN-BEFORE
                  <br />
                  Global marketing solution.
                </p>
              </div>
            </div>
            <div class="col-lg-5">
              <img
                src="{{ myLinksS3URL }}frontend/presentation13/images/right.png"
                class="img-fluid left m-ato"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-12 button-a text-center">
          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'regform'"
            class="font"
            >Become A Founder Now!</a
          >
        </div>
      </div>
    </div>

    <!------------section section--------------->

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-8">
              <div class="" data-aos="fade-left" data-aos-duration="1000">
                <h1 class="semibold">EXPERIENCE</h1>
                <br />
                <h2 class="semiflat">MARKETER'S MIRACLE</h2>
                <br />
                <p class="regular">
                  THE FOLLOWING INFORMATION WILL GIVE YOU A DETAILED KNOWLEDGE
                  OF OUR BUSINESS CONCEPT.
                </p>
                <p><br /></p>
                <p class="font1">
                  We invite you to step forward and experience, a life changing
                  opportunity that will allow your business to grow in all
                  possible directions.
                </p>
              </div>
            </div>
            <div class="col-lg-4 text-lg-right text-center mb-5 mt-5 mt-lg-0">
              <a
                href="#"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#myModal1"
              >
                <img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation13/images/video1.png"
                  class="main_image_one"
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="row justify-content-end mb--8">
            <div class="col-lg-6 green">
              <div class="text-white" data-aos="fade-left">
                <h2 class="extrabold size">
                  YOU GET ONE LIFE, MAKE IT WORTH LIVING
                </h2>
                <p><br /></p>

                <p class="size">
                  Do you believe in the power of the internet and the concept of
                  working from home?Watch through this video to get the golden
                  solutions for your unspoken obstacles jam-packed with unique
                  strategies.
                </p>
              </div>
            </div>

            <div class="col-lg-6 rightback">
              <div class="excuse-text" data-aos="fade-right">
                <h3 class="glacial">
                  THE MODERN MARKETING CONCEPT AIMS AT GIFTING YOU
                </h3>
                <ul>
                  <li>An Upgraded Marketing Automation</li>
                  <li>Guaranteed Web Traffic</li>
                  <li>Instant Earnings</li>
                </ul>

                <p>
                  Now that you have gone through the video, I believe that you
                  were facing the same issues which Mr. Mufareh spoke about.
                  However, I also believe that you have understood his plan and
                  strategy which he framed to help you consistently earn more.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div class="container-fluid background">
      <div class="row">
        <div class="col-lg-12"></div>
      </div>
    </div>
  </section>

  <section class="">
    <div class="container-fluid middlearea pb-0">
      <div class="container">
        <div class="row one-row">
          <div class="col-lg-12">
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
          </div>

          <div class="col-lg-4">
            <a
              href="#"
              data-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-target="#myModal2"
            >
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation13/images/secondvideo.png"
                class="main_image_one"
              />
            </a>
          </div>
          <div class="col-lg-8">
            <h1 class="text-white extrabold size1">
              DO YOU BELIEVE IN THE POWER OF THE INTERNET
            </h1>
            <h3 class="extrabold darkblue size2">
              AND THE CONCEPT OF WORKING FROM HOME ?
            </h3>
            <ul class="darkblue">
              <li>No Requirements</li>
              <li>No Recruiting</li>
              <li>No Auto-ship</li>
              <li>No Monthly Fees</li>
            </ul>
          </div>
        </div>
        <div class="row two-row">
          <div class="col-lg-12">
            <p><br /></p>
          </div>
          <div class="col-lg-9 ypadding">
            <h1 class="text-white extrabold">
              WHY GIVE AN EXCUSE, WHEN YOU CAN BE THE CHANGE ?
            </h1>
          </div>
          <div class="col-lg-3 gpadding">
            <h3 class="text-white">You can either :</h3>
          </div>

          <div class="col-lg-9 order-2 order-sm-0">
            <h1 class="text-white extrabold size3">
              I ACCEPTED THE SECOND OPTION. CHOOSE WISELY AND MAKE YOUR SMARTEST
              MOVE. YOU WILL BE GLAD OF THE REAL TIME RESULTS.
            </h1>
            <p><br /></p>
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="btn btn-warning rounded-0 founder"
              >BECOME A FOUNDER NOW!</a
            >
          </div>
          <div class="col-lg-3 bpadding">
            <ul class="text-white">
              <li>
                Wait for the business to launch and then select a package to
                become a founder if seats are available!
              </li>
              <p><br /></p>
              <p><br /></p>
              <li>
                Join today! Become a founder at a 90% discounted price of $97
                and be at the top. (highly recommended)
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid sunglass">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation13/images/middleside.png"
              class="img-responsive girl"
            />
            <a
              href="#"
              data-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-target="#myModal3"
              class="playbutton"
              ><img
                src="{{
                  myLinksS3URL
                }}frontend/presentation13/images/playbutton.png"
            /></a>
          </div>
          <div class="col-lg-5 blueback mt-5 text-center ml-0">
            <p class="text-white mt-5 glacial">
              Experience the countless benefits of the global business platform.
              Mr. Ash Mufareh and his more than two decades of working
              experience will help your business reach the unimaginable growth.
              Hundreds and thousands of dollars being invested to solve your
              financial Problems, and help you prosper in life. An extensive
              network of loyal resources and an aim to achieve the ultimate
              contributed to the making of O-Founders. Join us on our journey
              today!
            </p>
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="btn btn-warning rounded-0 founder1"
              >BECOME A FOUNDER NOW!</a
            >
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation13/images/3step.png"
                  class="img-responsive main_image_one"
                />
              </div>
              <div class="col-lg-6 list">
                <ul>
                  <li>
                    <a
                      href="javascript:void(0)"
                      class="btn btn-warning rounded-0 founder2"
                      >Fill Up The Basic Form</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      class="btn btn-warning rounded-0 founder1"
                      >Choose a favorable mode and pay.</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      class="btn btn-warning rounded-0 founder3"
                      >Be a founder!</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <p><br /></p>
            <p><br /></p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="sec">
    <div class="container-fluid">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 frmposition">
            <div class="newform mt-5" id="regform">
              <div class="panel-group cst"></div>

              <form [formGroup]="registerForm">
                <div class="row reg">
                  <div class="col-md-6">
                    <div class="d-block">
                      <input
                        matInput
                        type="text"
                        class="log_in_fild"
                        placeholder="First Name"
                        formControlName="firstname"
                        required
                      /><br />
                      <span
                        *ngIf="
                          registerForm.controls['firstname'].hasError(
                            'required'
                          ) && registerForm.controls['firstname'].touched
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        First Name Required.
                      </span>
                      <span
                        *ngIf="
                          registerForm.controls['firstname'].hasError(
                            'maxlength'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Min 1, max 50 characters.
                      </span>

                      <span
                        *ngIf="
                          registerForm.controls['firstname'].hasError(
                            'containOnlyNumbers'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Only numbers are not allowed.
                      </span>

                      <span
                        *ngIf="
                          registerForm.controls['firstname'].hasError(
                            'containOnlySpecialChars'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Only special characters are not allowed.
                      </span>

                      <span
                        *ngIf="
                          registerForm.controls['firstname'].hasError(
                            'containConsecutiveSpaces'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Consecutive spaces are not allowed.
                      </span>

                      <span
                        *ngIf="
                          registerForm.controls['firstname'].hasError(
                            'containConsecutiveDots'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Consecutive dots are not allowed.
                      </span>

                      <span
                        *ngIf="
                          registerForm.controls['firstname'].hasError(
                            'containConsecutiveHyphens'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Consecutive dashes are not allowed.
                      </span>

                      <span
                        *ngIf="
                          registerForm.controls['firstname'].hasError(
                            'containConsecutiveUnderScores'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Consecutive underscores are not allowed.
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-block">
                      <input
                        matInput
                        type="text"
                        placeholder="Last Name"
                        class="log_in_fild"
                        formControlName="lastname"
                        required
                      />
                      <span
                        *ngIf="
                          registerForm.controls['lastname'].hasError(
                            'required'
                          ) && registerForm.controls['lastname'].touched
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Last Name Required.
                      </span>
                      <span
                        *ngIf="
                          registerForm.controls['lastname'].hasError(
                            'maxlength'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Min 1, max 50 characters.
                      </span>
                      <span
                        *ngIf="
                          registerForm.controls['lastname'].hasError(
                            'containOnlyNumbers'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Only numbers are not allowed.
                      </span>
                      <span
                        *ngIf="
                          registerForm.controls['lastname'].hasError(
                            'containOnlySpecialChars'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Only special characters are not allowed.
                      </span>
                      <span
                        *ngIf="
                          registerForm.controls['lastname'].hasError(
                            'containConsecutiveSpaces'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Consecutive spaces are not allowed.
                      </span>
                      <span
                        *ngIf="
                          registerForm.controls['lastname'].hasError(
                            'containConsecutiveDots'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Consecutive dots are not allowed.
                      </span>
                      <span
                        *ngIf="
                          registerForm.controls['lastname'].hasError(
                            'containConsecutiveHyphens'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Consecutive dashes are not allowed.
                      </span>
                      <span
                        *ngIf="
                          registerForm.controls['lastname'].hasError(
                            'containConsecutiveUnderScores'
                          )
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Consecutive underscores are not allowed.
                      </span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="d-block">
                      <input
                        matInput
                        type="text"
                        placeholder="Phone Number"
                        class="log_in_fild"
                        formControlName="phone"
                        onKeyPress="if(this.value.length==20) return false;"
                        onkeydown="return event.keyCode !== 69"
                        required
                      />
                      <span
                        *ngIf="
                          registerForm.controls['phone'].hasError('required') &&
                          registerForm.controls['phone'].touched
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Phone number is required.
                      </span>
                      <span
                        *ngIf="
                          registerForm.controls['phone'].hasError('pattern')
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Only numbers are allowed.
                      </span>
                      <span
                        *ngIf="
                          registerForm.controls['phone'].hasError(
                            'minlength'
                          ) ||
                          registerForm.controls['phone'].hasError('maxlength')
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Min 6 and max 20 digits.
                      </span>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="d-block">
                      <input
                        matInput
                        type="text"
                        placeholder="Email Address"
                        class="log_in_fild"
                        formControlName="email"
                        required
                      />

                      <span
                        *ngIf="
                          registerForm.controls['email'].hasError('required') &&
                          registerForm.controls['email'].touched
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Email id Required.
                      </span>
                      <span
                        *ngIf="
                          registerForm.controls['email'].hasError('pattern')
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Please enter valid email.
                      </span>
                      <!-- <span *ngIf="registerForm.controls['email'].hasError('maxLength')" 
                                   class="failed-validation" style="color: red">
                                    Email length sould be less than 100.
                                  </span>-->
                    </div>
                  </div>
                </div>

                <div class="form-group d-block">
                  <div class="password-block">
                    <input
                      matInput
                      placeholder="Password"
                      formControlName="password"
                      class="log_in_fild"
                      [type]="pwdToggle ? 'text' : 'password'"
                      required
                    />
                    <button
                      type="button"
                      class="password-icon"
                      (click)="pwdToggle = !pwdToggle"
                    >
                      <i
                        class="fal"
                        [ngClass]="{
                          'fa-eye': pwdToggle,
                          'fa-eye-slash': !pwdToggle
                        }"
                      ></i>
                    </button>
                  </div>
                  <span
                    *ngIf="
                      registerForm.controls['password'].hasError('required') &&
                      registerForm.controls['password'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Password Required
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['password'].hasError('pattern')
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Password should contain minimum 8 Characters and Atleast one
                    Uppercase, One Lowercase, one Number and one Special
                    Characters
                  </span>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="d-block">
                      <select
                        formControlName="country_id"
                        required
                        class="log_in_fild"
                      >
                        <option value="">Select Country</option>
                        <option
                          *ngFor="let country of countriesList"
                          [value]="country.countryId"
                        >
                          {{ country.countryName }}
                        </option>
                      </select>
                      <span
                        *ngIf="
                          registerForm.controls['country_id'].hasError(
                            'required'
                          ) && registerForm.controls['country_id'].touched
                        "
                        class="failed-validation"
                        style="color: red"
                      >
                        Plese Select Country
                      </span>
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <div class="row no-gutters">
                        <div class="capcha">
                          <img [src]="imageCaptcha" style="width: 120px" />
                        </div>

                        <div>
                          <i
                            class="fa fa-refresh fa-lg"
                            aria-hidden="true"
                            (click)="regenerateCaptcha()"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="form-group">
                      <div class="main input-effect">
                        <input
                          id="capcha"
                          maxlength="5"
                          name="capcha"
                          type="text"
                          formControlName="enteredCaptcha"
                          placeholder=" Enter Captcha"
                          class="form-control effect-19"
                          required="required"
                        />
                        <span
                          *ngIf="
                            registerForm.controls['enteredCaptcha'].hasError(
                              'required'
                            ) && registerForm.controls['enteredCaptcha'].touched
                          "
                          class="failed-validation"
                          style="color: red"
                        >
                          Captcha Required
                        </span>
                      </div>
                    </div>
                  </div>
                </div> -->
                <div class="text-center">
                  <button
                    mat-raised-button
                    type="submit"
                    (click)="submitRegister()"
                    [disabled]="registerForm.invalid"
                    class="ibtn"
                  >
                    SignUp
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="col-lg-5 mt-5">
            <h1 class="extrabold yellow">WEBINAR</h1>
            <h3 class="upcoming text-white">UPCOMING WEBINAR</h3>
            <a
              href="#"
              class="
                btn btn-warning
                rounded-0
                founder1
                extrabold
                play_back_button
                aos-init aos-animate
              "
              data-aos="zoom-in"
              data-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-target="#previous"
            >
              <img
                src="{{ myLinksS3URL }}frontend/presentation13/images/play.png"
              />
              &nbsp;PREVIOUS WEBINAR PLAYBACK</a
            >
            <div class="d-none d-md-block">
              <p><br /></p>
              <p><br /></p>
              <p><br /></p>
              <p><br /></p>
            </div>

            <h1 class="text-white extrabold mt-4 mt-sm-0">
              WELCOME TO <br />
              O-FOUNDERS
            </h1>
            <p class="text-white glacial">
              In our Global Team there are real people who want to give you an
              Honest hand and help you succeed. Get started now to get more
              Details inside. You owe this to your family and yourself Our
              system is your opportunity of a lifetime It's been said that every
              person has only two real opportunities throughout their life, if
              you passed one, this could be your last chance. Don't miss out Get
              Started Now In minutes, you'll be glad you did.
            </p>
            <h3 class="text-white extrabold founder4">Already a Founder?</h3>
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="btn btn-warning rounded-0 founder4"
              >BECOME A FOUNDER NOW!</a
            >
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="text-center test-heading">
    <div class="container">
      <h1>TESTIMONIALS</h1>
    </div>
  </div>

  <section class="testimonials-wrapper position-relative mt-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-12">
          <div class="row justify-content-center">
            <div class="col-md-12"></div>

            <div class="col-md-12 text-center test_back_image">
              <div id="testimonial-slider" class="owl-carousel">
                <div class="testimonial-content row">
                  <div class="col-sm-5">
                    <h2>An ideal model for anyone</h2>

                    <p class="text-dark">
                      His drive and passion for creating a platform to help
                      everyone from seasoned marketers to the "little guy"
                      helped solidify my belief Then learning how we benefit
                      financially with optional starting points, makes this an
                      ideal model for anyone with a business who needs
                      advertising.
                    </p>
                    <p>
                      Thank you Ash for your vision and help for so many people
                      around the world.
                    </p>
                    <ul class="cd-author-info text-dark">
                      <li>Tim <strong>Leach</strong></li>
                      <li></li>
                    </ul>
                  </div>
                  <div class="col-sm-5 left">
                    <div class="cd-author">
                      <img
                        src="{{ cloudFrontUrl }}uploads/t1.png"
                        alt="Author image"
                      />
                    </div>
                  </div>
                  <div class="col-sm-2"></div>
                </div>

                <div class="testimonial-content row">
                  <div class="col-sm-5">
                    <h2>This Will Undoubtedly Change Your Life!</h2>

                    <p class="text-dark">
                      I want to personally say thank you to everyone on this
                      awesome journey that Ash Murareh has created. As many of
                      you may not know, Ash is a very successful online marketer
                      and has made his living in this industry building massive
                      teams for various companies. He saw a big need for
                      creating a company that would help the average person
                      succeed online so he decided to build it himself.
                    </p>

                    <p>
                      When you listen to his Founder's presentations or when you
                      speak with him, you will immediately feel his passion to
                      build a highly effective business where every single
                      person will be successful.
                    </p>
                    <ul class="cd-author-info text-dark">
                      <li>Mike <strong>Williams</strong></li>

                      <li></li>
                    </ul>
                  </div>
                  <div class="col-sm-5 left">
                    <div class="cd-author">
                      <img
                        src="{{ cloudFrontUrl }}uploads/t4.png"
                        alt="Author image"
                      />
                    </div>
                  </div>
                  <div class="col-sm-2"></div>
                </div>

                <div class="testimonial-content row">
                  <div class="col-sm-5">
                    <h2>
                      I am totally blown away and will build my final dynasty
                    </h2>

                    <p class="text-dark">
                      In my 19 years successful career in this space,I have
                      never seen a business so full, so disruptive, so
                      intriguing that everyone I approach is excited to belong.
                    </p>

                    <p class="text-dark">
                      Did a Facebook post, alongside my WhatsApp campaign, on
                      the founder position, that attracted 122 comments, 14
                      people have joined direct to me and in less than 48 hours,
                      59 super qualified leads have submitted their email,
                      requesting information to be founders, AND ALL THESE
                      WITHOUT ANYTHING YET ONGROUND, not even a website. I am
                      totally blown away and will build my final dynasty here in
                      ONPASSIVE.
                    </p>
                    <ul class="cd-author-info text-dark">
                      <li>PRINCE <strong>OBI</strong></li>
                      <li></li>
                    </ul>
                  </div>
                  <div class="col-sm-5 left">
                    <div class="cd-author">
                      <img
                        src="{{ cloudFrontUrl }}uploads/t2.png"
                        alt="Author image"
                      />
                    </div>
                  </div>
                  <div class="col-sm-2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="footer">
    <div class="text-center">
      <h1 class="extrabold">
        FOR A LITTLE WHILE YET, FOUNDER POSITIONS STILL AVAILABLE!
      </h1>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center">
            <h4>Copyright O-Founders 2022</h4>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="myModal1" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->

      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="first_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video1.pause(); video1.currentTime = 0"
          >
            &times;
          </button>
        </div>

        <video
          #video1
          id="my-video"
          class="video-js"
          controls
          preload="auto"
          poster="{{
            myLinksS3URL
          }}frontend/invitationfive/images/greeting1-new.png"
        >
          <source
            src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
            type="video/mp4"
          />

          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>

  <!----second modal------->
  <div id="myModal2" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->

      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="second_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video2.pause(); video2.currentTime = 0"
          >
            &times;
          </button>
        </div>

        <video
          #video2
          id="my-video1"
          class="video-js"
          controls
          preload="auto"
          poster="{{
            myLinksS3URL
          }}frontend/greetingsgofound/images/greeting2.png"
        >
          <source
            src="{{ myLinksS3URL }}videos/Video2-Compressed-new.mp4"
            type="video/mp4"
          />

          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>
  <!--------third video------------------------->
  <div id="myModal3" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->

      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="third_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video3.pause(); video3.currentTime = 0"
          >
            &times;
          </button>
        </div>

        <video
          #video3
          id="my-video2"
          class="video-js"
          controls
          preload="auto"
          poster="{{
            myLinksS3URL
          }}frontend/invitationfive/images/greeting3-new.png"
        >
          <source
            src="{{
              myLinksS3URL
            }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
            type="video/mp4"
          />

          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>

  <div id="previous" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->

      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            id="prev_video_pause"
            (click)="video4.pause(); video4.currentTime = 0"
          >
            &times;
          </button>
        </div>

        <video
          #video4
          width="100%"
          class="video-js"
          controls
          preload="auto"
          poster="{{ myLinksS3URL }}videos/title.jpg"
          id="my-video"
        >
          <source
            src="{{
              myLinksS3URL
            }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
            id="video"
            type="video/mp4"
          />

          Your browser does not support HTML5 video.
        </video>
      </div>
    </div>
  </div>

  <input type="hidden" id="urlId" value="" />

  <div class="country_popup_wrapper"></div>
</div>
